import {ModuleWithProviders, NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {LaPopoverComponent} from './la-popover.component';

@NgModule({
  imports: [
    CommonModule
  ],
  declarations: [LaPopoverComponent],
  exports: [LaPopoverComponent]
})
export class LaPopoverModule {
  static forRoot(): ModuleWithProviders {
    return {
      ngModule: LaPopoverModule,
      providers: []
    };
  }
}
